import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// When hosted on Firebase Hosting, authDomain must match the hosting origin so
// signInWithRedirect can complete without cross-origin storage issues.
// See https://firebase.google.com/docs/auth/web/redirect-best-practices
function resolveAuthDomain(): string {
    if (typeof window !== "undefined") {
        const host = window.location.hostname;
        if (
            host.endsWith(".web.app") ||
            host.endsWith(".firebaseapp.com") ||
            host.endsWith(".gcp.data.pncc.govt.nz") ||
            host === "ara.pncc.govt.nz"
        ) return host;
    }
    return import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
}

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: resolveAuthDomain(),
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
const firestoreDatabaseId = import.meta.env.VITE_FIRESTORE_DATABASE_ID;
const db = getFirestore(app, firestoreDatabaseId);
const auth = getAuth(app);

export { db, auth };
